<ces-error-page [code]="'pages.errors.404.title' | transloco" [heading]="'pages.errors.404.subtitle' | transloco" [showBack]="true">
  <p class="text-(color:--text-secondary)">{{ 'pages.errors.404.message' | transloco }}</p>
</ces-error-page>
